export default {
  default: () => import("/Users/darsh/Development/workspace-public-website/layouts/default.vue").then(m => m.default || m),
  home: () => import("/Users/darsh/Development/workspace-public-website/layouts/home.vue").then(m => m.default || m)
}